spApp.filter('allowIframe', ['$sce', function ($sce) {
  return (url) => {
    return $sce.trustAsResourceUrl(url);
  }
}]);